import { useState } from "react";
import { FileText } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useAuth } from "@/context/AuthContext";
import { API_URL } from "@/lib/api";

const SECTIONS = [
  { key: "overview", label: "Case information" },
  { key: "objectives", label: "Training objectives" },
  { key: "sessions", label: "Sessions delivered" },
  { key: "attendance", label: "Attendance" },
  { key: "levels", label: "Current independence levels" },
  { key: "outcome", label: "Final outcome" },
];

export default function CaseReportTab({ child }) {
  const { hasPermission } = useAuth();
  const [selected, setSelected] = useState(SECTIONS.map((s) => s.key));
  const canReport = hasPermission("reports:case") || hasPermission("children:read_all");

  if (!canReport) {
    return (
      <Card data-testid="case-report-denied"><CardContent className="p-6">
        <p className="text-sm text-slate-600">Case reports are available to authorised management. Use the other tabs for your authorised case information.</p>
      </CardContent></Card>
    );
  }

  const toggle = (k) => setSelected((cur) => (cur.includes(k) ? cur.filter((x) => x !== k) : [...cur, k]));
  const qs = selected.join(",");

  return (
    <div className="space-y-4" data-testid="reports-tab">
      <Card>
        <CardHeader><CardTitle className="text-lg flex items-center gap-2"><FileText className="h-5 w-5 text-primary" /> Individual case progress report</CardTitle></CardHeader>
        <CardContent className="space-y-3">
          <p className="text-xs text-slate-500">Select report sections. Safeguarding records are never included. Case ID is used instead of unnecessary personal details.</p>
          <div className="flex flex-wrap gap-2">
            {SECTIONS.map((s) => (
              <button key={s.key} type="button" data-testid={`report-section-${s.key}`} onClick={() => toggle(s.key)}
                className={`h-10 px-3 rounded-md border text-xs font-medium ${selected.includes(s.key) ? "bg-primary text-white border-primary" : "bg-white text-slate-600 border-border hover:bg-muted"}`}>
                {s.label}
              </button>
            ))}
          </div>
          <div className="flex flex-wrap gap-2">
            <a href={`${API_URL}/children/${child.id}/case-report.pdf?sections=${qs}`} target="_blank" rel="noreferrer" data-testid="case-report-pdf"
              className="inline-flex h-11 items-center gap-2 rounded-md bg-primary px-4 text-sm font-semibold text-white hover:bg-brand-hover">
              <FileText className="h-4 w-4" /> Case progress report (PDF)
            </a>
            <a href={`${API_URL}/children/${child.id}/commissioner-report.pdf`} target="_blank" rel="noreferrer" data-testid="commissioner-report-pdf"
              className="inline-flex h-11 items-center gap-2 rounded-md border border-border px-4 text-sm font-semibold text-slate-700 hover:bg-muted">
              <FileText className="h-4 w-4" /> Commissioner progress report (PDF)
            </a>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
